/* eslint-disable @wordpress/no-global-active-element */

class Tabs {
	constructor() {
		if (null === document.body) {
			return;
		}

		this.tabGroups = document.querySelectorAll('.tabs');
		this.tabLists = document.querySelectorAll('.tabs__list');
		this.tabButtons = document.querySelectorAll('.tabs__tab');

		this.tabGroups.forEach((tabs) => {
			const firstTab = tabs.querySelector('.tabs__tab');
			if (null !== firstTab) {
				this.setActiveTab(firstTab);
			}
		});

		this.tabButtons.forEach((button) => {
			button.addEventListener('click', this.handleButtonClick.bind(this));
		});

		this.checkOverflow();
		document.body.addEventListener('keyup', this.handleKeyUp.bind(this));
		window.addEventListener('load', this.checkOverflow.bind(this));
		window.addEventListener('resize', this.checkOverflow.bind(this));

		this.tabLists.forEach((list) => {
			list.querySelector('.tabs__list-inner').addEventListener('scroll', () =>
				this.setScrollClasses(list)
			);
		});
	}

	handleButtonClick(e) {
		this.setActiveTab(e.currentTarget);
	}

	handleKeyUp(e) {
		if (document.activeElement && document.activeElement.classList.contains('tabs__tab')) {
			switch (e.key) {
				case 'ArrowLeft':
					const prevTab = document.activeElement.previousElementSibling;
					if (null !== prevTab) {
						prevTab.focus();
						this.setActiveTab(prevTab);
					}
					break;

				case 'ArrowRight':
					const nextTab = document.activeElement.nextElementSibling;
					if (null !== nextTab) {
						nextTab.focus();
						this.setActiveTab(nextTab);
					}
					break;
			}
		}
	}

	setScrollClasses(list) {
		const listInner = list.querySelector('.tabs__list-inner');
		if (listInner.offsetWidth < listInner.scrollWidth) {
			list.classList.add('has-scroll');

			if (0 !== listInner.scrollLeft) {
				list.classList.add('has-scroll-left');
			} else {
				list.classList.remove('has-scroll-left');
			}

			if (Math.ceil(listInner.scrollLeft) + listInner.offsetWidth !== listInner.scrollWidth) {
				list.classList.add('has-scroll-right');
			} else {
				list.classList.remove('has-scroll-right');
			}
		} else {
			list.classList.remove('has-scroll');
		}
	}

	checkOverflow() {
		this.tabLists.forEach((list) => {
			this.setScrollClasses(list);
		});
	}

	setActiveTab(target) {
		if (!target.classList.contains('active')) {
			const targetPanel = document.getElementById(target.getAttribute('aria-controls'));
			target
				.closest('.tabs__list')
				.querySelectorAll('.tabs__tab')
				.forEach((tab) => {
					const tabPanel = document.getElementById(tab.getAttribute('aria-controls'));
					tab.classList.remove('active');
					tab.setAttribute('aria-selected', 'false');
					tab.setAttribute('tabindex', '-1');
					tabPanel.setAttribute('aria-hidden', 'true');
				});

			target.classList.add('active');
			target.setAttribute('aria-selected', 'true');
			target.removeAttribute('tabindex');
			targetPanel.setAttribute('aria-hidden', 'false');
		}
	}
}

new Tabs();
